/**
 * @param {Record<string, string | string[] | undefined>} errors
 * @returns {Record<string, string>}
 */
export function flattenSubmissionErrors(errors) {
    const flat = {};

    Object.entries(errors ?? {}).forEach(([key, value]) => {
        if (Array.isArray(value) && value.length > 0) {
            flat[key] = value[0] || 'Invalid value';
            return;
        }

        if (typeof value === 'string') {
            flat[key] = value;
        }
    });

    return flat;
}

/**
 * @param {Array<{ email?: string | null; type?: 'to'|'cc'|'bcc' | null }>} recipients
 * @returns {Array<{ email: string; type: 'to'|'cc'|'bcc' }>}
 */
export function normalizeRecipients(recipients = []) {
    return recipients
        .map((recipient) => {
            const email = typeof recipient.email === 'string' ? recipient.email.trim() : '';
            const type = recipient.type ?? 'to';
            if (!email) {
                return null;
            }

            return {
                email,
                type: type === 'cc' || type === 'bcc' ? type : 'to',
            };
        })
        .filter((recipient) => recipient !== null);
}

/**
 * @param {{
 *  formId?: string | null,
 *  pageId?: string,
 *  formData: Record<string, unknown>,
 *  recipients?: Array<{ email?: string | null; type?: 'to'|'cc'|'bcc' | null }>,
 *  subject?: string | null,
 *  replyTo?: string | null,
 *  honeypot?: string | null,
 * }} options
 */
export function buildSubmissionPayload(options) {
    return {
        form_id: options.formId?.trim() || null,
        page_id: options.pageId || window.location.pathname + window.location.search,
        form_data: options.formData,
        recipients: normalizeRecipients(options.recipients || []),
        ...(options.subject && options.subject.trim() !== '' ? { subject: options.subject.trim() } : {}),
        ...(options.replyTo && options.replyTo.trim() !== '' ? { reply_to: options.replyTo.trim() } : {}),
        ...(options.honeypot && options.honeypot.trim() !== '' ? { _hp_field: options.honeypot.trim() } : {}),
    };
}
